var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.74857 19.9559L3.56062 15.8203C3.18614 15.4375 3.14192 14.8406 3.45592 14.4068C3.62764 14.1512 3.90814 13.9894 4.21546 13.969C4.52278 13.9485 4.82226 14.0715 5.0264 14.3021L8.48146 17.7572L20.8359 5.40277C21.2527 5.09015 21.836 5.1316 22.2044 5.50003C22.5728 5.86846 22.6143 6.45173 22.3017 6.86855L9.21434 19.9559C9.02596 20.1612 8.76009 20.2781 8.48145 20.2781C8.20281 20.2781 7.93694 20.1612 7.74856 19.9559L7.74857 19.9559Z","fill":"#041E42"}));
}

IconCheck.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
